var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list-item",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.shouldShow,
          expression: "shouldShow",
        },
      ],
      class: { active: _vm.active },
      on: {
        click: function ($event) {
          return _vm.onFieldClick()
        },
      },
    },
    [
      _c("w-list-item-text", [
        _c("div", [
          _vm._v(_vm._s(_vm.name) + " "),
          _c("span", { staticClass: "preview-value" }, [
            _vm._v(_vm._s(_vm.previewValueText)),
          ]),
        ]),
      ]),
      _vm.canFavourite
        ? _c(
            "w-list-item-icon",
            {
              class: { favourite: _vm.favouriteIndex != -1 },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleFavourite()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: _vm.icon } })],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }